var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sex",
    transform: "translate(1831 -6946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "female_FILL1_wght400_GRAD0_opsz48",
    d: "M15.794,18V16.824H14.618v-.882h1.176v-1.5a3.105,3.105,0,0,1-2-1.081A3.172,3.172,0,0,1,13,11.221a3.092,3.092,0,0,1,.949-2.279,3.249,3.249,0,0,1,4.574,0,3.092,3.092,0,0,1,.949,2.279,3.172,3.172,0,0,1-.794,2.14,3.105,3.105,0,0,1-2,1.081v1.5h1.176v.882H16.676V18Zm.441-4.412a2.36,2.36,0,0,0,2.353-2.353,2.35,2.35,0,0,0-4.015-1.662,2.343,2.343,0,0,0,0,3.324A2.266,2.266,0,0,0,16.235,13.588Z",
    transform: "translate(-1844 6938)",
    fill: "#3281ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "male_FILL1_wght400_GRAD0_opsz48",
    d: "M17,8v3.094h-.844V9.448l-2.587,2.573a3.283,3.283,0,0,1,.457.893,3.116,3.116,0,0,1,.162.991A3.073,3.073,0,0,1,11.094,17,3.073,3.073,0,0,1,8,13.906a3.073,3.073,0,0,1,3.094-3.094,3.052,3.052,0,0,1,.984.162,3.31,3.31,0,0,1,.886.457l2.587-2.588H13.906V8Zm-5.906,3.656A2.247,2.247,0,0,0,9.5,15.5a2.241,2.241,0,0,0,3.178,0,2.25,2.25,0,0,0-1.589-3.839Z",
    transform: "translate(-1834 6942)",
    fill: "#3281ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSex);
export default __webpack_public_path__ + "static/media/Sex.997117c66704da4a676b69e5a423cee6.svg";
export { ForwardRef as ReactComponent };